import classnames from 'classnames';
import { AnimatePresence, motion } from 'framer-motion';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import analytics from '@utils/analytics';
import customEventBus from '@common/scripts/libs/eventBus';
import NewsletterErrorModal from './NewsletterErrorModal';
import NewsletterForm from './NewsletterForm';
import useBreakpoint from '@utils/useBreakpoint';
import cookie from 'react-cookies';
const NewsletterPopup = (props) => {
    const { t } = useTranslation();
    const [showPopup, setShowPopup] = useState(false);
    const [showForm, setShowForm] = useState(false);
    const [modalErrorMessage, setModalErrorMessage] = useState();
    const [submitSuccess, setSubmitSuccess] = useState(false);
    const currentBreakpoint = useBreakpoint();
    const isTablet = currentBreakpoint >= window.mqObj.sm && currentBreakpoint < window.mqObj.md && showForm ? '-50%' : 0;
    useEffect(() => {
        document.body.classList.toggle('remove-live-chat-icon', showPopup);
        return () => {
            document.body.classList.remove('remove-live-chat-icon');
        };
    });
    const showPopupDelayed = () => {
        if (!window.loggedin && sessionStorage.getItem('newsletter-popup') != 'closed') {
            if (!localStorage.SPPopupEndTime) {
                localStorage.SPPopupEndTime = +new Date() + 5000;
            }
            const interval = setInterval(() => {
                let remaining = localStorage.SPPopupEndTime - +new Date();
                if (remaining < 0) {
                    setShowPopup(window.datalayerdata.pageCategory !== 'pdp');
                    clearInterval(interval);
                }
            }, 15000);
        }
    };
    const hidePopup = () => {
        setShowPopup(false);
    };
    useEffect(() => {
        const isPDP = window.datalayerdata.pageCategory === 'pdp';
        // If it's a PDP, return early and don't execute the rest of the code
        if (isPDP) {
            return;
        }
        customEventBus.on('PDP:loaded', hidePopup);
        customEventBus.on('PLP:loaded', showPopupDelayed);
        // Suggested country match or modal close
        if (cookie.load('TC_PRIVACY_CENTER') || cookie.load('OptanonAlertBoxClosed')) {
            // Suggested country match or modal close
            customEventBus.on('suggestedCountry:close', showPopupDelayed);
        }
        return () => {
            customEventBus.off('PDP:loaded', hidePopup);
            customEventBus.off('PLP:loaded', showPopupDelayed);
        };
    }, []);
    useEffect(() => {
        const isPDP = window.datalayerdata.pageCategory === 'pdp';
        // If it's a PDP, return early and don't execute the rest of the code
        if (isPDP) {
            return;
        }
        customEventBus.on('PDP:loaded', hidePopup);
        if (window.cookiePolicy === 'OneTrust') {
            if (cookie.load('OptanonAlertBoxClosed')) {
                showPopupDelayed();
            }
            else {
                window.addEventListener('consent.onetrust', showPopupDelayed, { once: true });
            }
        }
        else if (!cookie.load('TC_PRIVACY_CENTER')) {
            customEventBus.on('cookieConsent:clicked', showPopupDelayed);
        }
        else {
            showPopupDelayed();
        }
        return () => {
            window.removeEventListener('consent.onetrust', showPopupDelayed);
            customEventBus.off('suggestedCountry:close', showPopupDelayed);
            customEventBus.off('cookieConsent:clicked', showPopupDelayed);
            customEventBus.off('PDP:loaded', hidePopup);
        };
    }, []);
    const subscribePopup = () => {
        analytics.newsletterSubscriptionPopup();
        setShowForm(true);
    };
    const closePopup = () => {
        setShowPopup(false);
        sessionStorage.setItem('newsletter-popup', 'closed');
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(AnimatePresence, null, showPopup && (React.createElement(motion.div, { className: classnames('newsletter-popup', { 'show-form': showForm }), 
            // className="newsletter-popup-div"
            transition: { type: 'tween', duration: 0.5, ease: [0.25, 1, 0.5, 1] }, initial: { y: '-100%', opacity: 0 }, animate: { y: isTablet ? '-50%' : 0, opacity: 1, x: isTablet ? '-50%' : 0 }, exit: { y: '-100%', opacity: 0 } },
            React.createElement("button", { onClick: closePopup, className: "newsletter-popup__close", "aria-label": t('button.close') },
                React.createElement("i", { className: "icon--close" })),
            !showForm ? (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "newsletter-popup__title-container" },
                    React.createElement("h2", { className: "newsletter-popup__title" }, t('newslettermodal.title'))),
                React.createElement("div", { className: "newsletter-popup__description-container" },
                    React.createElement("p", { className: "newsletter-popup__description" }, t('newslettermodal.popupdescription')),
                    React.createElement("button", { onClick: () => subscribePopup(), className: "button button--primary" }, t('newslettermodal.subscribe'))))) : (React.createElement("div", null, submitSuccess ? (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "newsletter-popup__title-container" },
                    React.createElement("h2", { className: "newsletter-modal__title", role: "alert" }, t('newslettermodal.successtitle'))),
                React.createElement("div", { className: "newsletter-popup__description-container" },
                    React.createElement("p", { className: "newsletter-modal__description" },
                        React.createElement("span", { dangerouslySetInnerHTML: { __html: t('newslettermodal.successdescription') } }),
                        React.createElement("button", { onClick: closePopup, className: "button button--primary" }, t('newslettermodal.continue')))))) : (React.createElement(React.Fragment, null,
                React.createElement("h2", { className: "newsletter-modal__title" }, t('newslettermodal.title')),
                React.createElement("p", { className: "newsletter-modal__description" },
                    React.createElement("span", null, t('newslettermodal.description'))),
                React.createElement(NewsletterForm, { isPopup: true, cookiepage: props.cookiepage, onSubmitSuccess: () => {
                        setSubmitSuccess(true);
                    } })))))))),
        React.createElement(NewsletterErrorModal, { isOpen: Boolean(modalErrorMessage === null || modalErrorMessage === void 0 ? void 0 : modalErrorMessage.title), modalErrorMessage: modalErrorMessage, onRequestClose: setModalErrorMessage })));
};
export default NewsletterPopup;
